import { useMutation } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import type { ResourceDownloadUrlData } from "@/hooks/queries/resource-types";

// Mint a pre-signed S3 GET URL for one reference document (Story 17.3).
//
// A MUTATION, never useQuery: a pre-signed URL is short-TTL and single-use, so it
// must NEVER be cached. Each click re-mints a FRESH URL (an expired URL is therefore
// never an issue), and the call writes a PHI-free `resource.downloaded` audit event
// server-side — so it must be 1:1 with a deliberate clinician click, never auto-fired
// on mount and never batched.
//
// `skipAuthRefresh` is OMITTED — this is a post-session data call that MUST ride the
// silent-refresh path (a 401 here is a stale access token, not a real auth failure;
// apiFetch refreshes and retries transparently).
export function useResourceDownload() {
  return useMutation({
    mutationFn: (id: string) =>
      apiFetch<ResourceDownloadUrlData>(`/resources/${id}/download-url`),
  });
}
